(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search"]) return;
  try {
    
  class SearchPageExtras extends HTMLElement {
    async connectedCallback() {
      const url = this.dataset.urlTemplate.replace('%%TERM%%', encodeURIComponent(this.dataset.searchTerm));

      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const results = documentFragment.querySelector('[data-search-page-predictive-fragment]');
        if (results) this.replaceChildren(...results.childNodes);
      } catch {}
    }
  }

  if (!customElements.get('search-page-extras')) {
    customElements.define('search-page-extras', SearchPageExtras);
  }

  } catch(e) { console.error(e); }
})();
})();
